import React from 'react';
export function FooterCTA() {
  return <section className="w-full bg-gradient-to-r from-light to-warm py-24 px-4 sm:px-6 lg:px-8 text-center" data-id="element-35">
      <div className="max-w-3xl mx-auto bg-white/40 backdrop-blur-md rounded-3xl p-10 md:p-16 shadow-xl border border-white/50" data-id="element-36">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-dark mb-6" data-id="element-37">
          Ești gata să faci primul pas pentru tine?
        </h2>
        <p className="text-lg md:text-xl text-dark/80 mb-10 max-w-2xl mx-auto font-medium" data-id="element-38">
          Rezervă o sesiune de consultanță cadou și hai să vedem împreună care
          este următorul pas potrivit pentru tine.
        </p>
        <a href="https://api.leadconnectorhq.com/widget/bookings/cmi-dr-cornelia-tianu-39b19d4e-46bc-4f77-b746-6d1dddacfb09" className="rounded-full bg-primary text-white font-semibold px-10 py-5 text-lg hover:bg-[#5A1D5F] transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 inline-block" data-id="element-39">
          Rezervă Sesiunea de Consultanță CADOU
        </a>
      </div>
    </section>;
}